import _BaseController from 'FF/Controllers/User/BaseController';
import HeaderController from 'Vue/Web/Header/HeaderController.vue';
import CookiePolicy from 'Vue/Web/Common/CookiePolicy.vue';

export default class extends _BaseController {
  HeaderControllerVue?: Vue;
  CookiePolicy ?: Vue;
  ready() {
    super.ready();

    this.HeaderControllerVue = new Vue(HeaderController);

    // promotionBar
    $('.promotionbar .close-btn').click(() => {
      $('.promotionbar').css('display', 'none');
    });

    this.CookiePolicy = new Vue({
      el: '.footer-bar',
      components: {
        CookiePolicy,
      },
    });

    $('#MsgModal').modal({backdrop:'static', keyboard: false});
  }
}
